(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["phc-size-help"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-phc-size-help-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.phcSizeHelpOpen);
    if (dialog && !dialog.open) dialog.showModal();
  }
  if (event.target.matches('dialog.phc-size-help')) {
    const box = event.target.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
  }
});
  } catch(e) { console.error(e); }
})();

})();
